import 'echarts-wordcloud';
import 'echarts-liquidfill'
// 人际关系环形图
export function relationPieEcharts (colorList, echarts) {
  let myChartWarnPie = echarts.init(document.getElementById("relationPieMain"));
  let optionWarnPie = {
    // color: ["#FFBD2A", "#B37FEB", "#4ACE82", "#59a4ff"],
    color: colorList,
    tooltip: {
      trigger: "item",
      // color: "black",
      // textStyle: {
      //   color: "#fff", //设置文字颜色
      // },
      // formatter: (params) => {
      //   return (
      //     params.name +
      //     "：" +
      //     params.value +
      //     "人" +
      //     "<br/>" +
      //     "占比：" +
      //     params.data.ratio +
      //     "%"
      //   );
      // },
    },
    legend: {
      show: false
      // orient: "vertical",
      // icon: "circle",
      // bottom: "15",
      // right: "0",
      // itemWidth: 8,
      // itemHeight: 8,
      // selectedMode: false,
      // textStyle: {
      //   color: "#595959",
      //   fontSize: 12,
      // },
    },
    series: [
      {
        type: "pie",
        radius: ["50%", "65%"],
        center: ["44%", "50%"],
        // avoidLabelOverlap: false,
        itemStyle: {
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          // show: true,
          normal: {
            width: 70,
            // overflow: 'breakAll',
            // formatter: (params) => {
            //   return `{name|${params.name}}` + "\n" + params.data.ratio + "%";
            // },
            color: "#595959",
            fontSize: 12,
            padding: [10, 10], //文字和图的边距
            rich: {
              name: {
                color: "#595959",
                fontSize: 12,
                lineHeight: 20,
              },
            },
          },
        },
        labelLine: {
          show: false,
          length: 12,
        },
        // data: data,
        data: [{ value: 64, name: '12333333' }]
      },
    ],
  };
  myChartWarnPie.setOption(optionWarnPie);
}
// 学会学习雷达图
export function radarEcharts (echarts) {
  // const { ratio, dimension, dataList } = echartsdata;
  let myChartWarnBar = echarts.init(document.getElementById("radarEcharts"));
  let optionWarnBar = {
    grid: {
      top: "10%",
      left: "0%",
      right: "0%",
      // bottom: 0,
      containLabel: true,
    },
    // radar: {
    //   splitArea: {
    //     show: false
    //   }
    // },
    tooltip: {
      trigger: "axis",
      // formatter: (params) => {
      //   return (
      //     params[0].name +
      //     "<br />" +
      //     params[0].data.text +
      //     "：" +
      //     params[0].value +
      //     "人" +
      //     "<br />" +
      //     "人数占比：" +
      //     params[1].value +
      //     "%"
      //   );
      // },
    },
    legend: {
      orient: 'vertical',              //这里主要是标识不同颜色代表不同的同学
      x: 'right',
      y: 'bottom',
      data: ['A同学成绩 ']
    },
    polar: [
      {
        indicator: [
          { text: '学习动力 ', max: 5.0, color: '#FF543A' },    //这里用于设置各轴的参数以及最大值
          { text: '学习能力 ', max: 5.0 },
          { text: '学习技能 ', max: 5.0 },
          { text: '学习状态', max: 5.0, color: '#FF543A' },
          { text: '学习情绪', max: 5.0, color: '#FF543A' },
        ]
      }
    ],
    calculable: true,
    series: [
      {
        type: 'radar',
        data: [
          {
            value: [4.8, 3, 3.2, 4.5, 4.6],
            name: 'A同学 '
          },
          // {
          //   value: [4.2, 4.1, 3.9, 3.7, 3.5],
          //   name: 'B同学 '
          // }
        ],
        areaStyle: {
          color: '#59A4FF'
        },
        label: {
          // show: true,
          normal: {
            fontSize: "0.07292rem"
          },
          // color: "#F6BD16",
          // data: ratio,
        },
      }
    ],
  };
  myChartWarnBar.setOption(optionWarnBar);
}
// 社会与适应水球图
export function echartsLiquidfill (echarts, dataObj) {
  // const { ratio, dimension, dataList } = echartsdata;
  let myChartWarnBar = echarts.init(document.getElementById(dataObj.id));
  let optionWarnBar = {
    grid: {
      top: 24,
      left: "0%",
      right: "0%",
      bottom: 0,
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      // formatter: (params) => {
      //   return (
      //     params[0].name +
      //     "<br />" +
      //     params[0].data.text +
      //     "：" +
      //     params[0].value +
      //     "人" +
      //     "<br />" +
      //     "人数占比：" +
      //     params[1].value +
      //     "%"
      //   );
      // },
    },
    series: [
      {
        type: 'liquidFill',
        radius: '85%',
        // data: [0.6, 0.5, 0.4, 0.3],
        // data: ratio,
        data: dataObj.data,
        outline: {
          show: false,
        },
        itemStyle: {
          opacity: 0.95,
          shadowBlur: 50,
          shadowColor: 'rgba(0, 0, 0, 0.4)',
          normal: {
            color: dataObj.color
          }
        },
        backgroundStyle: {
          borderWidth: 1,
          borderColor: "rgba(55, 211, 255, 0.42)",
          color: "rgba(0, 0, 0, 0)",
        },
        label: {
          position: ['50%', '50%'],
          formatter: function (data) {
            return data.value * 100
          },
          fontSize: "0.104rem",
          // color: '#D94854'
        }
      },
    ],
  };
  myChartWarnBar.setOption(optionWarnBar);
}
// 升学择业词云
export function echartsWordcloud (echarts) {
  // console.log(xData);
  let data = {
    value: [{
      name: '多元升学途径',
      value: 2181
    }, {
      name: '云计算',
      value: 1386
    }, {
      name: '物联网',
      value: 2055
    }, {
      name: '移动互联网',
      value: 2467
    }, {
      name: '人工智能',
      value: 2244
    }, {
      name: '深度学习',
      value: 1898
    }, {
      name: '机器学习',
      value: 1484
    }, {
      name: '区块链',
      value: 3865
    }, {
      name: '互联网+',
      value: 2222
    }, {
      name: '智能合约',
      value: 366
    }, {
      name: '比特币',
      value: 360
    }, {
      name: '数据挖掘',
      value: 273
    }],
    // value: xData,
    //小鸟图片
    image: require("../assets/studentImages/cloud.png"),

  };
  let myChart = echarts.init(document.getElementById('echartsWordcloud'));
  //温馨提示：image 选取有严格要求不可过大；，否则firefox不兼容  iconfont上面的图标可以
  let maskImage = new Image();
  maskImage.src = data.image;

  maskImage.onload = function () {
    myChart.setOption({
      // backgroundColor: '#fff',
      tooltip: {
        show: false,
      },
      series: [{
        type: 'wordCloud',
        gridSize: 1,
        sizeRange: [10, 36],
        rotationRange: [0, 0],
        maskImage: maskImage,
        textStyle: {
          color: function () {
            let colors = ['#FFAE00', '#59A4FF', '#B888EC', "#FF745C", "#73D99E"];
            return colors[parseInt(Math.random() * 5)];
          },
        },
        left: 'center',
        top: 'center',
        width: '100%',
        height: '100%',
        right: null,
        bottom: null,
        // width: 300,
        // height: 200,
        // top: 20,
        data: data.value,
      }],
    });
  };

}
// 情绪状态折线图
export function moodBarEcharts (echarts, moodBardata, id) {

  // const { ratio, dimension, dataList } = echartsdata;
  let myChartWarnBar = echarts.init(document.getElementById(id));
  let optionWarnBar = {
    grid: {
      top: 24,
      left: "10%",
      right: "10%",
      bottom: 0,
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      // formatter: (params) => {
      //   return (
      //     params[0].name +
      //     "<br />" +
      //     params[0].data.text +
      //     "：" +
      //     params[0].value +
      //     "人" +
      //     "<br />" +
      //     "人数占比：" +
      //     params[1].value +
      //     "%"
      //   );
      // },
    },
    xAxis: [
      {
        type: "category",
        data: moodBardata.dataX,
        axisLabel: {
          color: "#81868C",
          // margin: 30, // 刻度标签与轴线之间的距离
          interval: 4, // 坐标轴刻度标签的显示间隔
          // rotate: 20, // 刻度标签旋转的角度
          align: "center", // 文字水平对齐方式
          fontSize: "0.0625rem"
        },
        splitLine: {
          lineStyle: {
            color: "#F0F1F4",
          },
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        minInterval: 1,
        min: 65,
        splitLine: {
          lineStyle: {
            color: "#00D8EF",
            type: 'dashed'
          }
        },
        label: {
          show: false,
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff",
          },
        },
        axisLabel: {
          show: false
        }
      },
    ],
    legend: {
      show: true,
      orient: "vertical",
      icon: "circle",
      bottom: "15",
      right: "0",
      itemWidth: 8,
      itemHeight: 8,
      selectedMode: false,
      textStyle: {
        color: "#595959",
        fontSize: 12,
      },
    },
    series: [
      {
        type: "line",
        color: "#00D8EF",
        data: moodBardata.dataY,
        smooth: true,
      },
      {
        type: "line",
        color: "red",
        data: moodBardata.dataf,
      },
    ],
  };
  myChartWarnBar.setOption(optionWarnBar);
}

